import { useQuery } from "@tanstack/react-query";
import { fetchClientPhoneAutocomplete } from "@/lib/services/clientAutocompleteService";

/**
 * React Query hook for client phone autocomplete.
 * @param phoneStart - The starting digits of the phone (minimum 3 digits).
 */
export function useClientPhoneAutocomplete(phoneStart: string) {
  return useQuery({
    queryKey: ["clientPhoneAutocomplete", phoneStart],
    queryFn: () => fetchClientPhoneAutocomplete(phoneStart),
    enabled: !!phoneStart && phoneStart.length >= 3,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
